import React, { useState, useEffect,useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";


const LeaveBalanceModelPopup = ({ onSave, leaveTypeData, editModalVisible }) => {
  const [leaveBalances, setLeaveBalances] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const submitButtonRef = useRef(null);
  


  useEffect(() => {
    if (leaveTypeData) {
       // alert(JSON.stringify(leaveTypeData))
      const balances = Object.keys(leaveTypeData).filter(key => key.endsWith('_taken')).map(key => {
        const leaveType = key.replace('_taken', '');
        return {
          leaveType: leaveType,
          balance: leaveTypeData[leaveType],
          newBalance: leaveTypeData[leaveType],
          comment: ""
        };
      });
      setLeaveBalances(balances);
    } else {
      setLeaveBalances([]);
    }
  }, [leaveTypeData]);

  const handleBalanceChange = (index, event) => {
    const newBalances = [...leaveBalances];
    newBalances[index].newBalance = event.target.value;
    setLeaveBalances(newBalances);
  };

  const handleCommentChange = (index, event) => {
    const newBalances = [...leaveBalances];
    newBalances[index].comment = event.target.value;
    setLeaveBalances(newBalances);
  };

  const handleSubmit = () => {
 
    const isValid = leaveBalances.every(balance => balance.newBalance && !isNaN(balance.newBalance));

    if (isValid) {
        const payload = {
          leaveBalances: leaveBalances.map(balance => ({
            leaveType: balance.leaveType,
            leaveTypeId: leaveTypeData[`${balance.leaveType}_id`], // Add leave type id here
            newBalance: balance.newBalance,
            comment: balance.comment
          })),
        };
       
      const url = `${apiUrl}/leaves/update-leave-balances/${leaveTypeData.id}`;
      const method = "PUT";

      fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      })
        .then(response => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then(() => {
          onSave(payload.leaveBalances); // Pass the updated leave balances to onSave
          
          toast.success("Leave balance updated successfully");

          if (submitButtonRef.current) {
            submitButtonRef.current.click();
          }
     
        })
        .catch(error => {
          console.error("Error:", error);
          alert("An error occurred while submitting the form");
        });
    }
  };

  return (
    <div className="modal custom-modal fade" id="leave_balance_modal" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-lg" style={{ margin: 0, position: "fixed", right: 0, height: "100vh", width: "80%"}} role="document">
        <div className="modal-content h-100">
          <div className="modal-header">
            <h5 className="modal-title">Leave Balance</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body" style={{ maxHeight: "calc(100vh - 80px)", overflowY: "auto" }}>
            <div className="scrollable-container">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Leave Type</th>
                    <th>Balance</th>
                    <th>New Balance</th>
                    <th>Comments</th>
                  </tr>
                </thead>
                <tbody>
                  {leaveBalances.map((balance, index) => (
                    <tr key={index}>
                      <td>{balance.leaveType}</td>
                      <td>{balance.balance}</td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={balance.newBalance || ""}
                          onChange={event => handleBalanceChange(index, event)}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={balance.comment || ""}
                          onChange={event => handleCommentChange(index, event)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={handleSubmit}>Submit</button>
          </div>
          <div style={{ display: "none" }}>
        <button ref={submitButtonRef} data-bs-dismiss="modal" aria-label="Close" type="reset">
          Submit
        </button>
      </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveBalanceModelPopup;
